import React, { useContext, useEffect, useState } from "react";
import LoadingMain from "./Components/LoadingMain/LoadingMain";
import { HomeContext } from "./Context/HomeContext";

function AssetPreloader({ children }) {
  const { assetsLoaded, setAssetsLoaded, setImagesPreloaded } =
    useContext(HomeContext);

  useEffect(() => {
    // بارگذاری فایل JSON (آدرس را متناسب با مسیر واقعی در پروژه تغییر دهید)
    fetch("/Json/dataClient.json")
      .then((response) => response.json())
      .then((data) => {
        const { design } = data;

        // آرایه‌های منابع را تعریف می‌کنیم:
        const glbUrls = [];
        const imageUrls = [];
        const fontUrls = [];

        // از typeRose: استخراج مدل (.glb) و تصویر
        if (design.typeRose) {
          // glbUrls.push(design.typeRose[0].modelurl)
          imageUrls.push(design.typeRose[0].image);
          // design.typeRose.forEach((item) => {
          //   if (item.modelurl) glbUrls.push(item.modelurl);
          //   if (item.image) imageUrls.push(item.image);
          // });
        }

        // از colorRose: استخراج texture تصاویر
        if (design.colorRose) {
          // imageUrls.push(design.colorRose[0].texture);
          design.colorRose.forEach((color) => {
            if (color.texture) imageUrls.push(color.texture);
          });
        }

        // از text/textFont: استخراج فونت‌ها
        if (design.text && design.text.textFont) {
          design.text.textFont.forEach((font) => {
            if (font.url) fontUrls.push(font.url);
          });
        }

        if (design.packaging.quantity) {
          imageUrls.push(design.packaging.quantity[0].image);
          // design.packaging.quantity.forEach((item) => {
          //   if (item.image) imageUrls.push(item.image);
          // });
        }

        if (design.packaging.boxes.acrylic) {
          // glbUrls.push(design.packaging.boxes.acrylic[0].modelUrl);
          imageUrls.push(design.packaging.boxes.acrylic[0].imageSrc);
          // design.packaging.boxes.acrylic.forEach((item) => {
          //   if (item.modelUrl) glbUrls.push(item.modelUrl);
          //   if (item.imageSrc) imageUrls.push(item.imageSrc);
          // });
        }

        // پیش‌بارگذاری تصاویر .png، .webp و سایر فرمت‌های تصویری
        function preloadImage(src) {
          return new Promise((resolve, reject) => {
            const img = new Image();
            img.src = src;
            // img.onload = resolve;
            img.onload = () => resolve(img); // خود آبجکت تصویر رو برمی‌گردونیم
            img.onerror = reject;
          });
        }

        // پیش‌بارگذاری مدل‌های 3D (.glb)
        // function preloadGLB(src) {
        //   // استفاده از fetch برای دانلود فایل به صورت blob
        //   return fetch(src).then((res) => res.blob());
        // }

        // پیش‌بارگذاری فونت‌ها با استفاده از FontFace
        function preloadFont(src) {
          const font = new FontFace("CustomFont", `url(${src})`);
          return font.load().then((loadedFont) => {
            document.fonts.add(loadedFont);
          });
        }

        // تعریف Promise برای هر دسته از منابع
        // const modelPromises = glbUrls.map(preloadGLB);
        const imagePromises = imageUrls.map(preloadImage);
        // setImagesPreloaded(imageUrls)
        const fontPromises = fontUrls.map(preloadFont);

        // انتظار تا همه منابع بارگذاری شوند ...modelPromises
        // Promise.all([ ...imagePromises, ...fontPromises])
        //   .then(() => setAssetsLoaded(true))
        //   .catch((err) => console.error("خطا در پیش‌بارگذاری منابع:", err));
        Promise.all([...imagePromises, ...fontPromises])
          .then((results) => {
            const loadedImages = results.filter(
              (item) => item instanceof Image
            );
            setImagesPreloaded(loadedImages); // یا setCachedImages(loadedImages)
            setAssetsLoaded(true);
          })
          .catch((err) => console.error("خطا در پیش‌بارگذاری منابع:", err));
      })
      .catch((err) => console.error("خطا در بارگذاری فایل JSON:", err));
  }, []);

  if (!assetsLoaded) {
    return <LoadingMain />;
  }

  return children;
}

export default AssetPreloader;
